const l = "_bullets_6zdkw_1", t = {
  bullets: l
};
export {
  l as bullets,
  t as default
};
//# sourceMappingURL=index.es2352.js.map
